import { Component, OnInit } from '@angular/core';
import {GlobalServices} from '../global.services';
import {ApiService} from '../api.service';

@Component({
  selector: 'app-verifymail',
  templateUrl: './verifymail.component.html',
  styleUrls: ['./verifymail.component.scss']
})
export class VerifymailComponent implements OnInit {

  public token;
  public responsemsg;
  constructor(public globalServices: GlobalServices, private httpService: ApiService) {

    if (this.globalServices.isBrowser) {
      const queryString = window.location.search;
      // console.log(queryString);
      this.token = queryString.split('=')[1];
      let url = "verify/token?token=" + this.token;
      this.httpService.getuserData(url).subscribe(response => {
        if (response['status']) {
          this.responsemsg = true;
          let userDetails = localStorage.getItem('userDetails') ? JSON.parse(localStorage.getItem('userDetails')) : null;
          userDetails['isEmailVerify'] = 1;
          localStorage.setItem('userDetails', JSON.stringify(userDetails));
        } else {
          this.responsemsg = false;
        }
      });
    }
  }

  ngOnInit(): void {
  }

}
